module.exports = __webpack_public_path__ + "static/media/instagram_icon.d24a2851.JPG";